var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChangePasswordModal',{attrs:{"id":"change-password-screen-modal","persistOnClickBackdrop":true,"cancel":_vm.logOut,"cancelTitle":"Sign Out","cancelVariant":"danger standard-btn"}})
}
var staticRenderFns = []

export { render, staticRenderFns }